(function(w, $) {
	function getFormattedDate() {
		const today = new Date();
		const yyyy = today.getFullYear();
		let mm = today.getMonth() + 1;
		let dd = today.getDate();

		if (dd < 10) dd = '0' + dd;
		if (mm < 10) mm = '0' + mm;

		return `${yyyy}-${mm}-${dd}`;
	}

	function getParam(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name) ?? '';
	}

	// Adapted from https://codepen.io/bananascript/pen/EyZeWm
	const confetti = function() {
		// Globals
		let random = Math.random
			, cos = Math.cos
			, sin = Math.sin
			, PI = Math.PI
			, PI2 = PI * 2
			, timer = undefined
			, frame = undefined
			, confetti = [];
	
		let   spread = 40
			, sizeMin = 3
			, sizeMax = 12 - sizeMin
			, eccentricity = 10
			, deviation = 100
			, dxThetaMin = -0.1
			, dxThetaMax = -dxThetaMin - dxThetaMin
			, dyMin = 0.13
			, dyMax = 0.18
			, dThetaMin = 0.4
			, dThetaMax = 0.7 - dThetaMin;
	
		const colors = [
			[10, 34, 64],
			[177, 32, 40],
			[228, 61, 48],
			[255, 92, 53],
			[248, 141, 42],
			[255, 181, 72],
		];
	
		let colorThemes = [
			function() {
				const c = colors[Math.floor(Math.random()*colors.length)];
				return color(...c);
				//   return color(200 * random()|0, 200 * random()|0, 200 * random()|0);
			}, function() {
				let black = 200 * random()|0; return color(200, black, black);
			}, function() {
				let black = 200 * random()|0; return color(black, 200, black);
			}, function() {
				let black = 200 * random()|0; return color(black, black, 200);
			}, function() {
				return color(200, 100, 200 * random()|0);
			}, function() {
				return color(200 * random()|0, 200, 200);
			}, function() {
				let black = 256 * random()|0; return color(black, black, black);
			}, function() {
				return colorThemes[random() < 0.5 ? 1 : 2]();
			}, function() {
				return colorThemes[random() < 0.5 ? 3 : 5]();
			}, function() {
				return colorThemes[random() < 0.5 ? 2 : 4]();
			},
		];
		function color(r, g, b) {
			return 'rgb(' + r + ',' + g + ',' + b + ')';
		}
	
		// Cosine interpolation
		function interpolation(a, b, t) {
			return (1-cos(PI*t))/2 * (b-a) + a;
		}
	
		// Create a 1D Maximal Poisson Disc over [0, 1]
		let radius = 1/eccentricity, radius2 = radius+radius;
		function createPoisson() {
		// domain is the set of points which are still available to pick from
		// D = union{ [d_i, d_i+1] | i is even }
			let domain = [radius, 1-radius], measure = 1-radius2, spline = [0, 1];
			while (measure) {
				let dart = measure * random(), i, l, interval, a, b, c, d;
	
				// Find where dart lies
				for (i = 0, l = domain.length, measure = 0; i < l; i += 2) {
					a = domain[i], b = domain[i+1], interval = b-a;
					if (dart < measure+interval) {
						spline.push(dart += a-measure);
						break;
					}
					measure += interval;
				}
				c = dart-radius, d = dart+radius;
	
				// Update the domain
				for (i = domain.length-1; i > 0; i -= 2) {
					l = i-1, a = domain[l], b = domain[i];
					// c---d          c---d  Do nothing
					//   c-----d  c-----d    Move interior
					//   c--------------d    Delete interval
					//         c--d          Split interval
					//       a------b
					if (a >= c && a < d)
						if (b > d) domain[l] = d; // Move interior (Left case)
						else domain.splice(l, 2); // Delete interval
					else if (a < c && b > c)
						if (b <= d) domain[i] = c; // Move interior (Right case)
						else domain.splice(i, 0, c, d); // Split interval
				}
	
				// Re-measure the domain
				for (i = 0, l = domain.length, measure = 0; i < l; i += 2)
					measure += domain[i+1]-domain[i];
			}
	
			return spline.sort();
		}
	
		// Create the overarching container
		let container = document.createElement('div');
		container.style.position = 'fixed';
		container.style.top      = '0';
		container.style.left     = '0';
		container.style.width    = '100%';
		container.style.height   = '0';
		container.style.overflow = 'visible';
		container.style.zIndex   = '9999';
	
		// Confetto constructor
		function Confetto(theme) {
			this.frame = 0;
			this.outer = document.createElement('div');
			this.inner = document.createElement('div');
			this.outer.appendChild(this.inner);
	
			let outerStyle = this.outer.style, innerStyle = this.inner.style;
			outerStyle.position = 'absolute';
			outerStyle.width  = (sizeMin + sizeMax * random()) + 'px';
			outerStyle.height = (sizeMin + sizeMax * random()) + 'px';
			innerStyle.width  = '100%';
			innerStyle.height = '100%';
			innerStyle.backgroundColor = theme();
	
			outerStyle.perspective = '50px';
			outerStyle.transform = 'rotate(' + (360 * random()) + 'deg)';
			this.axis = 'rotate3D(' +
			cos(360 * random()) + ',' +
			cos(360 * random()) + ',0,';
			this.theta = 360 * random();
			this.dTheta = dThetaMin + dThetaMax * random();
			innerStyle.transform = this.axis + this.theta + 'deg)';
	
			this.x = window.innerWidth * random();
			this.y = -deviation;
			this.dx = sin(dxThetaMin + dxThetaMax * random());
			this.dy = dyMin + dyMax * random();
			outerStyle.left = this.x + 'px';
			outerStyle.top  = this.y + 'px';
	
			// Create the periodic spline
			this.splineX = createPoisson();
			this.splineY = [];
			let l;
			for (let i = 1, l = this.splineX.length-1; i < l; ++i)
				this.splineY[i] = deviation * random();
			this.splineY[0] = this.splineY[l] = deviation * random();
	
			this.update = function(height, delta) {
				this.frame += delta;
				this.x += this.dx * delta;
				this.y += this.dy * delta;
				this.theta += this.dTheta * delta;
	
				// Compute spline and convert to polar
				let phi = this.frame % 7777 / 7777, i = 0, j = 1;
				while (phi >= this.splineX[j]) i = j++;
				let rho = interpolation(
					this.splineY[i],
					this.splineY[j],
					(phi-this.splineX[i]) / (this.splineX[j]-this.splineX[i]),
				);
				phi *= PI2;
	
				outerStyle.left = this.x + rho * cos(phi) + 'px';
				outerStyle.top  = this.y + rho * sin(phi) + 'px';
				innerStyle.transform = this.axis + this.theta + 'deg)';
				return this.y > height+deviation;
			};
		}
	
		function poof() {
			if (!frame) {
			// Append the container
				document.body.appendChild(container);
	
				// Add confetti
				let theme = colorThemes[0];
				(function addConfetto() {
					let confetto = new Confetto(theme);
					confetti.push(confetto);
					container.appendChild(confetto.outer);
					timer = setTimeout(addConfetto, spread * random());
				})(0);
	
				// Start the loop
				let prev = undefined;
				requestAnimationFrame(function loop(timestamp) {
					let delta = prev ? timestamp - prev : 0;
					prev = timestamp;
					let height = window.innerHeight;
	
					for (let i = confetti.length-1; i >= 0; --i) {
						if (confetti[i].update(height, delta)) {
							container.removeChild(confetti[i].outer);
							confetti.splice(i, 1);
						}
					}
	
					if (timer || confetti.length)
						return frame = requestAnimationFrame(loop);
	
					// Cleanup
					document.body.removeChild(container);
					frame = undefined;
				});
			}
		}
	
		poof();
	};
  
	function handleHsAddStylesOnFormReady($form) {
		$form.append($(`
			<style>
				@import url('https://fonts.googleapis.com/css2?family=Roboto+Flex:opsz,wght@8..144,600&display=swap');

				.rs-btn,
				.hbspt-form .hs_submit input[type="submit"],
				.hbspt-form .hs_submit input[type="submit"]:hover {
					display: inline-flex;
					justify-content: center;
					align-items: center;
					line-height: 0 !important;
					padding: 0 20px !important;
					height: auto;
					min-height: 40px;
					color: rgba(255 255 255) !important;
					border: 1px solid rgba(177 32 40) !important;
					background-color: rgba(177 32 40) !important;
					text-transform: uppercase;
					letter-spacing: 1px;
					font-size: 16px !important;
					border-radius: 4px !important;
					cursor: pointer;
					transition: filter 0.25s;
					font-family: "Roboto Flex", sans-serif !important;
					font-optical-sizing: auto;
					font-weight: 600;
					font-style: normal;
					font-variation-settings:
						"slnt" 0,
						"wdth" 100,
						"GRAD" 0,
						"XOPQ" 96,
						"XTRA" 468,
						"YOPQ" 79,
						"YTAS" 750,
						"YTDE" -203,
						"YTFI" 738,
						"YTLC" 514,
						"YTUC" 712;
				}

				.rs-btn,
				.hbspt-form .hs_submit input[type="submit"]:hover {
					filter: brightness(115%);
				}

				.rs-btn.rs-btn-secondary {
					border: 1px solid #ff5c36 !important;
					background-color: #ff5c36 !important;
				}

				.rs-btn.rs-btn-small {
					min-height: 30px;
					font-size: 10px !important;
				}
			</style>
		`));
	}

	// Add a dropdown and country search for mobile phone
	// https://github.com/jackocnr/intl-tel-input
	function handleMobilePhoneFieldOnFormReady($form) {
		const $hsMobilePhoneField = $form.find('.hs_mobilephone .input');

		if($hsMobilePhoneField.length <= 0) {
			return;
		}

		const $hsMobilePhoneInput = $hsMobilePhoneField.find('input');

		$('<link>')
			.attr('rel', 'stylesheet')
			.attr('type', 'text/css')
			.attr('href', 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.6.0/build/css/intlTelInput.css')
			.on('load', function() {
				// Hide the whole thing until the CSS loads, otherwise we get a FLOC specifically with a long
				// list of countries off the page
				$form.find('.iti').addClass('iti-styles-loaded');
			})
			.appendTo($form);

		$form.append($(`
			<style>
				.iti {
					display: none;
				}

				.iti.iti-styles-loaded {
					display: inline-block;
				}

				input#mobile-phone {
				    font-family: inherit;
					font-size: inherit;
					line-height: inherit;
					width: 100%;
					min-height: 40px !important;
					padding: 6px 12px 6px 48px !important;
					border-radius: 3px;
					border: 1px solid rgb(203, 214, 226);
					background-color: rgb(245, 248, 250);
					color: rgb(51, 71, 91);
				}

				.phone-invalid input#mobile-phone {
					border-color: rgb(200, 120, 114);
				}

				.iti {
					width: 100%;
					font-family: arial, helvetica, sans-serif;
				}
				input[name="mobilephone"] {
					display: none;
				}
			</style>
		`));

		$hsMobilePhoneField.append($(`
			<input id="mobile-phone" />
		`));

		const $customInput = $hsMobilePhoneField.find('#mobile-phone');

		const telInput = window.intlTelInput($customInput.get(0), {
		  	loadUtilsOnInit: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.6.0/build/js/utils.js',
			initialCountry: 'au',
			strictMode: true,
			countryOrder: ['au', 'nz'],
			useFullscreenPopup: false,
		});

		function syncNumber() {
			const isValid = telInput.isValidNumber();

			$hsMobilePhoneField.toggleClass('phone-valid', !!isValid);
			$hsMobilePhoneField.toggleClass('phone-invalid', !isValid);
			
			if(!isValid) {
				$hsMobilePhoneInput.val('').change();
				return;
			}

			$hsMobilePhoneInput.val(telInput.getNumber()).change();
		}

		$customInput.on('change', syncNumber);
		$customInput.on('countrychange', syncNumber);

		const currentValue = $hsMobilePhoneInput.val();
		if(currentValue) {
			telInput.setNumber(currentValue);
		}
	}

	// Add a dropdown and seach for country field
	// https://github.com/mrmarkfrench/country-select-js
	// based on phone one above (https://github.com/jackocnr/intl-tel-input)
	function handleCountryFieldOnFormReady($form) {
		const $hsCountryField = $form.find('.hs_country .input');

		if($hsCountryField.length <= 0) {
			return;
		}

		const $dropdown = $(`
			<select class="hs-input school-name-dropdown"></select>
		`);
		$hsCountryField.append($dropdown);

		// testing...
		// 	$hsCountryField.find('input').val('Australia').change();
		// 	$hsCountryField.find('input').val('New Zealand').change();
		// 	$hsCountryField.find('input').val('').change();
		// 	$hsCountryField.find('input').val('Not Exists').change();

		const countries = [
			{id: 'au', text: 'Australia'},
			{id: 'nz', text: 'New Zealand'},
			{id: '', text: '---------', disabled: true},
			{id: 'af', text: 'Afghanistan'},
			{id: 'al', text: 'Albania'},
			{id: 'dz', text: 'Algeria'},
			{id: 'as', text: 'American Samoa'},
			{id: 'ad', text: 'Andorra'},
			{id: 'ao', text: 'Angola'},
			{id: 'ai', text: 'Anguilla'},
			{id: 'aq', text: 'Antarctica'},
			{id: 'ag', text: 'Antigua and Barbuda'},
			{id: 'ar', text: 'Argentina'},
			{id: 'am', text: 'Armenia'},
			{id: 'aw', text: 'Aruba'},
			{id: 'at', text: 'Austria'},
			{id: 'az', text: 'Azerbaijan'},
			{id: 'bs', text: 'Bahamas'},
			{id: 'bh', text: 'Bahrain'},
			{id: 'bd', text: 'Bangladesh'},
			{id: 'bb', text: 'Barbados'},
			{id: 'by', text: 'Belarus'},
			{id: 'be', text: 'Belgium'},
			{id: 'bz', text: 'Belize'},
			{id: 'bj', text: 'Benin'},
			{id: 'bm', text: 'Bermuda'},
			{id: 'bt', text: 'Bhutan'},
			{id: 'bo', text: 'Bolivia'},
			{id: 'bq', text: 'Bonaire, Sint Eustatius and Saba'},
			{id: 'ba', text: 'Bosnia and Herzegovina'},
			{id: 'bw', text: 'Botswana'},
			{id: 'bv', text: 'Bouvet Island'},
			{id: 'br', text: 'Brazil'},
			{id: 'io', text: 'British Indian Ocean Territory'},
			{id: 'bn', text: 'Brunei Darussalam'},
			{id: 'bg', text: 'Bulgaria'},
			{id: 'bf', text: 'Burkina Faso'},
			{id: 'bi', text: 'Burundi'},
			{id: 'kh', text: 'Cambodia'},
			{id: 'cm', text: 'Cameroon'},
			{id: 'ca', text: 'Canada'},
			{id: 'cv', text: 'Cape Verde'},
			{id: 'ky', text: 'Cayman Islands'},
			{id: 'cf', text: 'Central African Republic'},
			{id: 'td', text: 'Chad'},
			{id: 'cl', text: 'Chile'},
			{id: 'cn', text: 'China'},
			{id: 'cx', text: 'Christmas Island'},
			{id: 'cc', text: 'Cocos (Keeling) Islands'},
			{id: 'co', text: 'Colombia'},
			{id: 'km', text: 'Comoros'},
			{id: 'cg', text: 'Congo'},
			{id: 'cd', text: 'Congo, Democratic Republic of the'},
			{id: 'ck', text: 'Cook Islands'},
			{id: 'cr', text: 'Costa Rica'},
			{id: 'ci', text: "Côte d'Ivoire"},
			{id: 'hr', text: 'Croatia'},
			{id: 'cu', text: 'Cuba'},
			{id: 'cw', text: 'Curaçao'},
			{id: 'cy', text: 'Cyprus'},
			{id: 'cz', text: 'Czechia'},
			{id: 'dk', text: 'Denmark'},
			{id: 'dj', text: 'Djibouti'},
			{id: 'dm', text: 'Dominica'},
			{id: 'do', text: 'Dominican Republic'},
			{id: 'ec', text: 'Ecuador'},
			{id: 'eg', text: 'Egypt'},
			{id: 'sv', text: 'El Salvador'},
			{id: 'gq', text: 'Equatorial Guinea'},
			{id: 'er', text: 'Eritrea'},
			{id: 'ee', text: 'Estonia'},
			{id: 'sz', text: 'Eswatini'},
			{id: 'et', text: 'Ethiopia'},
			{id: 'fk', text: 'Falkland Islands (Malvinas)'},
			{id: 'fo', text: 'Faroe Islands'},
			{id: 'fj', text: 'Fiji'},
			{id: 'fi', text: 'Finland'},
			{id: 'fr', text: 'France'},
			{id: 'gf', text: 'French Guiana'},
			{id: 'pf', text: 'French Polynesia'},
			{id: 'tf', text: 'French Southern Territories'},
			{id: 'ga', text: 'Gabon'},
			{id: 'gm', text: 'Gambia'},
			{id: 'ge', text: 'Georgia'},
			{id: 'de', text: 'Germany'},
			{id: 'gh', text: 'Ghana'},
			{id: 'gi', text: 'Gibraltar'},
			{id: 'gr', text: 'Greece'},
			{id: 'gl', text: 'Greenland'},
			{id: 'gd', text: 'Grenada'},
			{id: 'gp', text: 'Guadeloupe'},
			{id: 'gu', text: 'Guam'},
			{id: 'gt', text: 'Guatemala'},
			{id: 'gg', text: 'Guernsey'},
			{id: 'gn', text: 'Guinea'},
			{id: 'gw', text: 'Guinea-Bissau'},
			{id: 'gy', text: 'Guyana'},
			{id: 'ht', text: 'Haiti'},
			{id: 'hm', text: 'Heard Island and McDonald Islands'},
			{id: 'va', text: 'Holy See'},
			{id: 'hn', text: 'Honduras'},
			{id: 'hk', text: 'Hong Kong'},
			{id: 'hu', text: 'Hungary'},
			{id: 'is', text: 'Iceland'},
			{id: 'in', text: 'India'},
			{id: 'id', text: 'Indonesia'},
			{id: 'ir', text: 'Iran'},
			{id: 'iq', text: 'Iraq'},
			{id: 'ie', text: 'Ireland'},
			{id: 'im', text: 'Isle of Man'},
			{id: 'il', text: 'Israel'},
			{id: 'it', text: 'Italy'},
			{id: 'jm', text: 'Jamaica'},
			{id: 'jp', text: 'Japan'},
			{id: 'je', text: 'Jersey'},
			{id: 'jo', text: 'Jordan'},
			{id: 'kz', text: 'Kazakhstan'},
			{id: 'ke', text: 'Kenya'},
			{id: 'ki', text: 'Kiribati'},
			{id: 'kp', text: 'Korea (North)'},
			{id: 'kr', text: 'Korea (South)'},
			{id: 'kw', text: 'Kuwait'},
			{id: 'kg', text: 'Kyrgyzstan'},
			{id: 'la', text: 'Lao People\'s Democratic Republic'},
			{id: 'lv', text: 'Latvia'},
			{id: 'lb', text: 'Lebanon'},
			{id: 'ls', text: 'Lesotho'},
			{id: 'lr', text: 'Liberia'},
			{id: 'ly', text: 'Libya'},
			{id: 'li', text: 'Liechtenstein'},
			{id: 'lt', text: 'Lithuania'},
			{id: 'lu', text: 'Luxembourg'},
			{id: 'mo', text: 'Macao'},
			{id: 'mg', text: 'Madagascar'},
			{id: 'mw', text: 'Malawi'},
			{id: 'my', text: 'Malaysia'},
			{id: 'mv', text: 'Maldives'},
			{id: 'ml', text: 'Mali'},
			{id: 'mt', text: 'Malta'},
			{id: 'mh', text: 'Marshall Islands'},
			{id: 'mq', text: 'Martinique'},
			{id: 'mr', text: 'Mauritania'},
			{id: 'mu', text: 'Mauritius'},
			{id: 'yt', text: 'Mayotte'},
			{id: 'mx', text: 'Mexico'},
			{id: 'fm', text: 'Micronesia'},
			{id: 'md', text: 'Moldova'},
			{id: 'mc', text: 'Monaco'},
			{id: 'mn', text: 'Mongolia'},
			{id: 'me', text: 'Montenegro'},
			{id: 'ms', text: 'Montserrat'},
			{id: 'ma', text: 'Morocco'},
			{id: 'mz', text: 'Mozambique'},
			{id: 'mm', text: 'Myanmar'},
			{id: 'na', text: 'Namibia'},
			{id: 'nr', text: 'Nauru'},
			{id: 'np', text: 'Nepal'},
			{id: 'nl', text: 'Netherlands'},
			{id: 'nc', text: 'New Caledonia'},
			{id: 'ni', text: 'Nicaragua'},
			{id: 'ne', text: 'Niger'},
			{id: 'ng', text: 'Nigeria'},
			{id: 'nu', text: 'Niue'},
			{id: 'nf', text: 'Norfolk Island'},
			{id: 'mk', text: 'North Macedonia'},
			{id: 'mp', text: 'Northern Mariana Islands'},
			{id: 'no', text: 'Norway'},
			{id: 'om', text: 'Oman'},
			{id: 'pk', text: 'Pakistan'},
			{id: 'pw', text: 'Palau'},
			{id: 'ps', text: 'Palestine, State of'},
			{id: 'pa', text: 'Panama'},
			{id: 'pg', text: 'Papua New Guinea'},
			{id: 'py', text: 'Paraguay'},
			{id: 'pe', text: 'Peru'},
			{id: 'ph', text: 'Philippines'},
			{id: 'pn', text: 'Pitcairn'},
			{id: 'pl', text: 'Poland'},
			{id: 'pt', text: 'Portugal'},
			{id: 'pr', text: 'Puerto Rico'},
			{id: 'qa', text: 'Qatar'},
			{id: 're', text: 'Réunion'},
			{id: 'ro', text: 'Romania'},
			{id: 'ru', text: 'Russia'},
			{id: 'rw', text: 'Rwanda'},
			{id: 'bl', text: 'Saint Barthélemy'},
			{id: 'sh', text: 'Saint Helena, Ascension and Tristan da Cunha'},
			{id: 'kn', text: 'Saint Kitts and Nevis'},
			{id: 'lc', text: 'Saint Lucia'},
			{id: 'mf', text: 'Saint Martin (French part)'},
			{id: 'pm', text: 'Saint Pierre and Miquelon'},
			{id: 'vc', text: 'Saint Vincent and the Grenadines'},
			{id: 'ws', text: 'Samoa'},
			{id: 'sm', text: 'San Marino'},
			{id: 'st', text: 'Sao Tome and Principe'},
			{id: 'sa', text: 'Saudi Arabia'},
			{id: 'sn', text: 'Senegal'},
			{id: 'rs', text: 'Serbia'},
			{id: 'sc', text: 'Seychelles'},
			{id: 'sl', text: 'Sierra Leone'},
			{id: 'sg', text: 'Singapore'},
			{id: 'sx', text: 'Sint Maarten (Dutch part)'},
			{id: 'sk', text: 'Slovakia'},
			{id: 'si', text: 'Slovenia'},
			{id: 'sb', text: 'Solomon Islands'},
			{id: 'so', text: 'Somalia'},
			{id: 'za', text: 'South Africa'},
			{id: 'gs', text: 'South Georgia and the South Sandwich Islands'},
			{id: 'ss', text: 'South Sudan'},
			{id: 'es', text: 'Spain'},
			{id: 'lk', text: 'Sri Lanka'},
			{id: 'sd', text: 'Sudan'},
			{id: 'sr', text: 'Suriname'},
			{id: 'sj', text: 'Svalbard and Jan Mayen'},
			{id: 'se', text: 'Sweden'},
			{id: 'ch', text: 'Switzerland'},
			{id: 'sy', text: 'Syrian Arab Republic'},
			{id: 'tw', text: 'Taiwan'},
			{id: 'tj', text: 'Tajikistan'},
			{id: 'tz', text: 'Tanzania'},
			{id: 'th', text: 'Thailand'},
			{id: 'tl', text: 'Timor-Leste'},
			{id: 'tg', text: 'Togo'},
			{id: 'tk', text: 'Tokelau'},
			{id: 'to', text: 'Tonga'},
			{id: 'tt', text: 'Trinidad and Tobago'},
			{id: 'tn', text: 'Tunisia'},
			{id: 'tr', text: 'Turkey'},
			{id: 'tm', text: 'Turkmenistan'},
			{id: 'tc', text: 'Turks and Caicos Islands'},
			{id: 'tv', text: 'Tuvalu'},
			{id: 'ug', text: 'Uganda'},
			{id: 'ua', text: 'Ukraine'},
			{id: 'ae', text: 'United Arab Emirates'},
			{id: 'gb', text: 'United Kingdom'},
			{id: 'us', text: 'United States'},
			{id: 'um', text: 'United States Minor Outlying Islands'},
			{id: 'uy', text: 'Uruguay'},
			{id: 'uz', text: 'Uzbekistan'},
			{id: 'vu', text: 'Vanuatu'},
			{id: 've', text: 'Venezuela'},
			{id: 'vn', text: 'Vietnam'},
			{id: 'vg', text: 'Virgin Islands (British)'},
			{id: 'vi', text: 'Virgin Islands (U.S.)'},
			{id: 'wf', text: 'Wallis and Futuna'},
			{id: 'eh', text: 'Western Sahara'},
			{id: 'ye', text: 'Yemen'},
			{id: 'zm', text: 'Zambia'},
			{id: 'zw', text: 'Zimbabwe'},
		];

		const currentValue = $hsCountryField.find('input').val();
		if(currentValue) {
			const currentCountry = countries.find(country => country.text.toLowerCase() === currentValue.toLowerCase());
			if(currentCountry) {
				currentCountry.selected = true;
			} else {
				// If the country is not in the list, add it as a custom option
				countries.splice(2, 0, {id: 'currentValue', text: currentValue, selected: true});
			}
		} else {
			const defaultCountry = countries[0];
			defaultCountry.selected = true;
			$hsCountryField.find('input').val(defaultCountry.text).change();
		}


		const select2 = $dropdown.select2({
			dropdownParent: $form.parent(),
			width: '100%',
			data: countries,
		}).on('select2:select', function(e) {
			const data = e.params.data;
			$hsCountryField.find('input').val(data.text).change();
		});

		// For some reason the events break and don't close internally when you click outside the input
		// this I think has to do with the `dropdownParent` setting
		$form.on('click', function(e) {
			if($(e.target).closest('.hs_country').length >= 1) {
				return;
			} 
			
			select2.select2('close');
		});
		// expectedly the events on the parent page can't influence this stuff, so add that, too
		$(document).on('click', function() {
			select2.select2('close');
		});

		$hsCountryField.find('input').hide();
	}

	
	function handleSelect2StylesOnFormReady($form) {
		const $hsSelectableFields = $form.find('.hs_school_linker .input, .hs_country .input');

		if($hsSelectableFields.length <= 0) {
			return;
		}

		$form.append($(`
			<link href="https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css" rel="stylesheet" />
			<style>
				form {
					padding-bottom: 100px;
				}

				.select2-container,
				.select2 {
					font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
					font-size: 16px;
				}

				@media (min-width: 443px) {
					.select2-container,
					.select2 {
						width: 90% !important;
					}

					.hs-custom-style fieldset>div:last-of-type .select2-container {
						width: 100% !important;
					}
				}	

				.select2-container--default .select2-selection--single {
					background-color: #f5f8fa;
					border-color: #cbd6e2;
					padding: 5px;
					height: 40px;
				}

				.select2-container--default .select2-selection--single .select2-selection__rendered {
					color: #33475b;
				}

				.select2-container--default .select2-selection--single .select2-selection__arrow {
					top: 7px;
					right: 4px;
				}

				.select2-container--open .select2-dropdown--below {
					background-color: #f5f8fa;
					border-color: #cbd6e2;
				}

				.select2-results__message,
				.select2-results__option {
					color: #33475b;
				}

				.select2-search--dropdown {
					padding: 6px 12px;
				}
				.select2-container--default .select2-search--dropdown .select2-search__field {
					font-size: 16px;
					border-radius: 3px;
					padding: 9px 10px;
				}
				.select2-results {
					padding: 4px 10px 6px 10px;
				}
				.select2-results__option {
					border-radius: 3px;
				}
			</style>
		`));
	}

	// Changes the school linker field from a text input to a full school name
	// by searching our DB of all schools in AUS. When this field changes we have a 
	// HS hook we catch to then associate this contact to that company
	function handleHsLinkerFieldOnFormReady($form) {
		const $hsLinkerField = $form.find('.hs_school_linker .input');

		if($hsLinkerField.length <= 0) {
			return;
		}

		const onlyPartnerSchools = ($form.attr('data-form-id') === 'ecf46997-ed63-4871-b799-72524c529810');
		const chooseSchoolText = 'Choose school';
		$form.append($(`
			<style>
				.select2-container--default .select2-selection--single .select2-selection__rendered[title="${chooseSchoolText}"] {
					color: #bfbfbf;
				}
			</style>
		`));

		const $hsEmailInput = $form.find('.hs_email input');
		$hsLinkerField.find('input').hide();

		const $dropdown = $(`
			<select class="hs-input school-name-dropdown">
				<option selected disabled>${chooseSchoolText}</option>
			</select>
		`);
		$hsLinkerField.append($dropdown);
		const url = window.rsWebsite.portal.ajaxUrl + `?action=api&controller=${(onlyPartnerSchools ? 'publicSchool' : 'publicAustralianSchool')}&method=search`

		const select2 = $dropdown.select2({
			tags: true,
			dropdownParent: $form.parent(),
			width: '100%',
			insertTag: function (data, tag) {
				if(onlyPartnerSchools) {
					return;
				}

				tag.text = `Can't find your school? Just use: ${tag.text}`;
				data.unshift(tag);
			},
			ajax: {
				dataType: 'json',
				url,
				delay: 200,
				data: function (params) {
					const ret = {
						search: params.term,
						domain: '',
					};

					// If the user has put in their email already, lets get the domain and pass it to 
					// the searcher so that we can automatically return a school if they have that domain
					// But only if we don't have a term yet
					if(!params.term) {
						const email = $hsEmailInput.val();
						const emailParts = email.split('@');
						if(emailParts.length >= 1) {
							const domain = emailParts[emailParts.length - 1];
							ret.domain = domain;							
						}
					}

					return ret;
				},
				processResults: function (res) {
					return {
						results: res.data.map(function(i) {
							// placeholder will be the correct format
							if(i.id) {
								return i;
							}

							// but data from the API might not be, well, isn't, so format it here
							return {
								id: i.name,
								text: i.name,
							}
						}),
					};
				},
			},
		}).on('select2:select', function(e) {
			const data = e.params.data;
			$hsLinkerField.find('input').val(data.id).change();
		}).one('select2:open', function() {
			$form.parent().find('input.select2-search__field').attr('placeholder', 'Start typing...');
		});

		// For some reason the events break and don't close internally when you click outside the input
		// this I think has to do with the `dropdownParent` setting
		$form.on('click', function(e) {
			if($(e.target).closest('.hs_school_linker').length >= 1) {
				return;
			} 
			
			select2.select2('close');
		});
		// expectedly the events on the parent page can't influence this stuff, so add that, too
		$(document).on('click', function() {
			select2.select2('close');
		});
	}

	// If there is the "Event | Attended" HS property in this form then change the event name field
	// into a drop down, and only show events that are today or in the past
	// If there is an eventName param, preset the event name field.
	// If there is an allEvents param show all events (ignore the date restriction) and when an event is chosen 
	// then copy its key to the clipboard. This can be used for prefilling.
	function handleEventNamePickerOnFormReady($form) {
		const chosenEventName = getParam('eventName');
		const $eventNameContainer = $form.find('.hs_event_name');
		const $eventNameInputOriginal = $eventNameContainer.find('> .input textarea');

		// If the chosen name param is set then just hide the field.
		if(chosenEventName) {
			$eventNameInputOriginal
				.val(chosenEventName).change()
				.closest('.hs-form-field').hide();
		}

		// If there isn't an Event | Attended property then don't do any more
		const $hsEventFieldContainer = $form.find('.hs_event___attended___2025').hide();
		if(chosenEventName || $hsEventFieldContainer.length <= 0) {
			return;
		}

		$form.append($(`
			<style>
				.hs-custom-style .hs-dependent-field>div .hs-input:not([type=checkbox]):not([type=radio]) {
					width: 90%;
				}

				.hs_event_name {
					padding-right: 8px;
				}
			</style>
		`));

		// Get all the options form the Event | Attended property
		const today = getFormattedDate();
		const showAllEvents = getParam('allEvents');
		const options = $hsEventFieldContainer
			.find('.input ul li')
			.toArray()
			.reduce(function(acc, li) {
				const $li = $(li);
				const label = $li.find('span').text();
				// If we don't do this, then todays date compares aren't included
				const labelDateCompare = label.substring(0, 10);

				// Unless we are showing all events, then only show those which are today or have passed
				if(!showAllEvents && !chosenEventName) {
					if(labelDateCompare.localeCompare(today) > 0 || labelDateCompare.localeCompare('2024-01-01') < 0) {
						return acc;
					}
				}

				acc.push({
					label: label,
					value: $li.find('input').attr('value'),
				});

				return acc;
			}, []);

		if(!options.length) {
			return;
		}

		$eventNameContainer.find('> .input').hide();
		
		const $eventNameDropdown = $(`
			<select class="hs-input event-name-dropdown">
				<option selected disable>Choose event</option>
				${options.map(function(opt) {
		return `<option value="${opt.value}" data-label="${opt.label}">${opt.label}</option>`;
	}).join('')}
			</select>

		`);
		$eventNameContainer.append($eventNameDropdown);

		$eventNameDropdown.on('change', function() {
			$eventNameInputOriginal.val($(this).val()).change(); 
			if(showAllEvents) {
				const selectedEventName = $(this).find('option:selected').attr('value');
				try {
					navigator.clipboard.writeText(selectedEventName);
				} catch (error) {
					console.log(error);
				}
				
				console.log(`Event name value chosen: ${selectedEventName}`);
			}
		});
	}

	window.rsKeynoteCalendlyEmbed = function() {
		const div = document.createElement('div');
    	const script = document.scripts[document.scripts.length - 1];
		div.id = 'calendly-embed';
		script.parentElement.insertBefore(div, script);

		const params = new URLSearchParams(window.location.search);

		const calendlyScript = document.createElement('script');
		calendlyScript.addEventListener('load', () => {
			Calendly.initInlineWidget({
				url: 'https://calendly.com/d/cst9-nrp-g6g/school-culture-discovery-conversation-with-real-schools?hide_event_type_details=1&hide_gdpr_banner=1',
				resize: true,
				parentElement: div,
				prefill: {
					name: params.get('n') ?? '',
					email: params.get('email') ?? '',
					customAnswers: {
						a1: params.get('mobilephone') ?? '',
						a2: params.get('school') ?? '',
						a3: params.get('state') ?? '',
					},
				},
			});
			
		});
		calendlyScript.src = 'https://assets.calendly.com/assets/external/widget.js';
		const head = document.head || document.getElementsByTagName('head')[0];
		head.insertBefore(calendlyScript, head.firstChild);
	}

	// When a keynote form is submitted we need to redirect to a thank you page
	// based on the job title. We also need to pass the name, email, mobile phone,
	// params in the URL so that Calendly can use them as needed
	function handleKeynoteEnquiryFormOnFormSubmitted(data) {
		const isLeadership = ['principal', 'assistant-principal', 'head-of-college', 'senior-leader'];
		let redirectUrl = window.location.origin + window.location.pathname;
		if(isLeadership.includes(data.submissionValues.job_title_new)) {
			redirectUrl += 'thankyou/';
		} else {
			redirectUrl += 'thank-you/';
		}

		const formSubmission = data.submissionValues;
		const url = new URL(redirectUrl);
		url.search = new URLSearchParams({
			// Can't use name beacuse it fucks with Wordpress routing
			n: `${formSubmission.firstname} ${formSubmission.firstname}`,
			email: formSubmission.email,
			mobilephone: formSubmission.mobilephone,
			school: formSubmission.school_linker,
			state: formSubmission.state_aus.toUpperCase(),
		});
		
		window.location.href = url.toString();
	}

	function hideMobileExceptWhenLeadership($form) {
		const $mobilePhoneField = $form.find('.hs_mobilephone');
		const $jobTitleField = $form.find('.hs_job_title_new');

		if($mobilePhoneField.length <= 0 || $jobTitleField.length <= 0) {
			return;
		}

		$mobilePhoneField.hide();

		const isLeadership = ['principal', 'assistant-principal', 'head-of-college', 'senior-leader'];
		$jobTitleField.find('select').on('change', function() {
			const val = $(this).val();
			if(isLeadership.includes(val)) {
				$mobilePhoneField.show();
			} else {
				$mobilePhoneField.hide();
			}
		});
	}

	function enlargeCheckboxField($form, fieldName) {
		const $partnerStatusField = $form.find(`.hs-form-field[class*="${fieldName}"]`);
		$partnerStatusField.find('.input input').attr('type', 'checkbox');

		$form.append($(`
			<style>
				.hs-form-field[class*="${fieldName}"] > label {
					display: none;
				}

				.hs-form-field[class*="${fieldName}"] .input label {
					font-size: 20px;
					max-width: 600px;
					line-height: 1.2;
					margin-bottom: 30px;
					position: relative;
					margin-left: 50px;
				}

				.hs-form-field[class*="${fieldName}"] .input input {
					position: absolute;
					top: 3px;
					transform: scale(1.5);
					left: -36px;
				}
			</style>
		`));
	}

	function handlePartnershipTierSetting($form) {
		const tier = getParam('tier');
		if(!tier) {
			return;
		}

		if(!['platinum', 'gold', 'silver', 'bronze'].includes(tier)) {
			return;
		}

		let $selectedLi;

		const $tierField = $form.find('.hs-form-field[class*="partnership_tier"]');
		$tierField.find('input').each(function() {
			const $input = $(this);
			const value = $input.attr('value').toLowerCase();
			if(value === tier) {
				$input.prop('checked', true).trigger('change').hide();

				$selectedLi = $input.closest('li');
				
			}
		});

		if($selectedLi.length <= 0) {
			return;	
		}

		$tierField.find('.hs-form-required').hide();

		$selectedLi.find('span').css({
			'font-size': '17px',
			'font-weight': 'bold',
		});
		$selectedLi.closest('ul').css({
			'padding-left': '0',
		});

		$tierField.find('li').not($selectedLi).hide();
	}

	function enlargeRadioField($form, fieldName) {
		$form.append($(`
			<style>
				.hs-form-field[class*="${fieldName}"] {
					margin-bottom: 40px;
				}

				.hs-form-field[class*="${fieldName}"] > label {
					font-size: 20px !important;
					max-width: 600px;
					line-height: 1.2;
					margin-bottom: 15px;
				}
			</style>
		`));
	}

	function handleRestoringTeachingAutoRedirectOnFormReady() {
		const alreadySubmitted = window.localStorage.getItem('rs.forms.RestoringTeachingSubmitted');
		if(!alreadySubmitted) {
			return;
		}

		window.location.href = '/rt/resources/';
	}

	function handleNonPartnerPhdPurchaseRedirectOnFormSubmitted(data) {
		if(data.submissionValues.payment_preference === 'Invoice') {
			return;
		}

		const quantiyStripeMap = {
			1: 'https://payment.realschools.com.au/b/9AQbIL77M7hU0sU6op',
			2: 'https://payment.realschools.com.au/b/3cscMP8bQ7hU5Ne4gi',
			3: 'https://payment.realschools.com.au/b/3cs6orbo2byacbC7sv',
			4: 'https://payment.realschools.com.au/b/6oE8wzbo231EdfGdQU',
			5: 'https://payment.realschools.com.au/b/cN2bIL2Rw1XAa3u149',
			6: 'https://payment.realschools.com.au/b/6oEfZ1bo26dQ0sU14a',
			7: 'https://payment.realschools.com.au/b/aEU5kndwa31E4Ja8wD',
			8: 'https://payment.realschools.com.au/b/3cs8wz0Jo6dQ1wY8wE',
			9: 'https://payment.realschools.com.au/b/7sI147cs6dGia3u009',
			10: 'https://payment.realschools.com.au/b/eVa4gjgIm8lYejK8wG',
		};
		const teachersFieldJson = data.submissionValues.repeating_fields_capturer.substring(3).trim();
		const teachers = teachersFieldJson ? JSON.parse(teachersFieldJson) : [];
		const totalTeachers = teachers.length + 1;
		const stripeUrl = quantiyStripeMap[totalTeachers];
		window.location.href = `${stripeUrl}?prefilled_email=${encodeURI(data.submissionValues.email)}`;
	}

	function handleRp2OnlineRedirectOnFormSubmitted(data) {
		if(data.submissionValues.payment_preference === 'Invoice') {
			return;
		}

		window.location.href = 'https://payment.realschools.com.au/b/dR6cMPdwadGib7y000?prefilled_email=' + encodeURI(data.submissionValues.email);
	}

	function handleLeadGenerationRedirect(data) {
		const url = new URL(window.location.pathname, window.location.origin);
		const newUrl = new URL('thankyou', url);
		newUrl.search = new URLSearchParams({
			fName: data.submissionValues.firstname,
			lName: data.submissionValues.lastname,
			email: data.submissionValues.email,
			school: data.submissionValues.school_linker,
			jobTitle: data.submissionValues.job_title_new,
			optIn: data.submissionValues.marketing_opt_in,
			type: 'lead-generation',
			gen: window.location.pathname,
		});

		window.location.href = newUrl.toString();
	}


	function handleRestoringTeachingAutoRedirectOnFormSubmitted() {
		window.localStorage.setItem('rs.forms.RestoringTeachingSubmitted', true);
	}

	function handlePhdTicketDetailsField($form) {
		let count = 0;
		let teachers = [];

		const updateRepeatingData = function() {
			teachers = [];
			$form.find('.teachers .teacher').each(function() {
				const $teacher = $(this);

				teachers.push({
					firstName: $teacher.find('[name="teacher-first-name"]').val(),
					lastName: $teacher.find('[name="teacher-last-name"]').val(),
					email: $teacher.find('[name="teacher-email"]').val(),
					jobTitle: $teacher.find('[name="job-title-custom"]').val(),
				});
			});

			$form.find('#repeating_fields_capturer-2c6a71f0-2db0-4b0f-8b97-5d31a885b888').val(`PHD
				${JSON.stringify(teachers)}
			`).change();
		}

		const teacherHtml = function(number) {
			return $(`
				<div class="teacher">
					<fieldset class="form-columns-2">
						<div class="hs_teacher-first-name hs-teacher-first-name hs-fieldtype-text field hs-form-field">
							<label id="label-teacher-first-name-custom${number}" class="" placeholder="Teacher first name" for="teacher-first-name-custom${number}">
								<span>First name</span>
								<span class="hs-form-required">*</span>
							</label>
							<legend class="hs-field-desc" style="display: none;"></legend>
							<div class="input">
								<input id="teacher-first-name-custom${number}" name="teacher-first-name" required="" placeholder="" type="text" class="hs-input" inputmode="text" value="">
							</div>
						</div>
						<div class="hs_teacher-last-name hs-teacher-last-name hs-fieldtype-text field hs-form-field">
							<label id="label-teacher-last-name-custom${number}" class="" placeholder="Teacher last name" for="teacher-last-name-custom${number}">
								<span>Last name</span>
								<span class="hs-form-required">*</span>
							</label>
							<legend class="hs-field-desc" style="display: none;"></legend>
							<div class="input">
								<input id="teacher-last-name-custom${number}" name="teacher-last-name" required="" placeholder="" type="text" class="hs-input" inputmode="text" value="">
							</div>
						</div>
					</fieldset>
					<fieldset class="form-columns-2">
						<div class="hs_teacher-email hs-teacher-email hs-fieldtype-text field hs-form-field">
							<label id="label-teacher-email-custom${number}" class="" placeholder="Teacher first name" for="teacher-email-custom${number}">
								<span>Email</span>
								<span class="hs-form-required">*</span>
							</label>
							<legend class="hs-field-desc" style="display: none;"></legend>
							<div class="input">
								<input id="teacher-email-custom${number}" name="teacher-email" required="" placeholder="" type="text" class="hs-input" inputmode="text" value="">
							</div>
						</div>
						
						<div class="hs_job-title hs-job-title hs-fieldtype-select field hs-form-field">
							<label id="label-job-title-custom${number}" class="" placeholder="Enter your Ticket Quantity" for="job-title-custom${number}">
								<span>Job title</span>
							</label>
							<legend class="hs-field-desc" style="display: none;"></legend>
							<div class="input">
								<select id="job-title-custom${number}" required="" class="hs-input" name="job-title-custom">
									<option value="principal">Principal</option>
									<option value="assistant-principal">Assistant/Deputy Principal</option>
									<option value="head-of-college">Head of College</option>
									<option value="senior-leader">Senior Leader</option>
									<option value="wellbeing-coordinator">Wellbeing Coordinator</option>
									<option value="head-of-teaching">Head of Teaching and Learning</option>
									<option value="teacher" selected>Teacher</option>
									<option value="career-advisor">Career Advisor</option>
									<option value="admin">Administration</option>
									<option value="accounts">Accounts</option>
									<option value="business-manager">Business Manager</option>
									<option value="other">Other</option>
								</select>
							</div>
						</div>
					</fieldset>
					<div class="remove-teacher-container">
						<button class="remove-teacher" title="Remove this teacher">&times;</button>
					</div>
				</div>
			`);
		}

		$form.find('.hs_repeating_fields_capturer').closest('fieldset').after($(`
			<div class="teachers-container">
				<h3>Enrol multiple teachers?</h3>
				<div class="sub-title">If you want to enrol more than 10 people, please <a target="_blank" href="mailto:info@realschools.com.au?subject=Bulk%20PhD%20Enrolment">contact us</a>.</div>
				<div class="teachers"></div>
				<button class="teacher-button rs-btn rs-btn-secondary rs-btn-small" id="add-teacher">Add another teacher</button>
				<style>
					.sub-title {
						font-weight: 300;
						font-size: 11px;
						position: relative;
						top: -15px;
						color: #8a8a8a;
					}
					.sub-title a {
						color: inherit !important;
					}
					.teachers-container {
						margin: 30px 0 50px 0;
						font-family: "Roboto Flex", sans-serif;
						position: relative;
					}
					
					.teachers-container .teacher {
						margin-bottom: 30px;
					}

					.teachers-container .teacher .remove-teacher-container {
						display: flex;
						justify-content: flex-end;
						padding-right: 8px;
					}

					.teachers-container .teacher .remove-teacher-container .remove-teacher {
						width: 30px;
						height: 30px;
						display: flex
						align-items: center;
						justify-content: center;
						border: 1px solid #cad6e1;
						background: #f6f8fa;
						border-radius: 3px;
						font-size: 20px;
						cursor: pointer;
					}
				</style>
			</div>
		`));

		$form.on('click', '#add-teacher', function(e) {
			e.preventDefault();

			if(teachers.length >= 9) {
				alert('If you want to enrol more than 10 teachers, please email us at info@realschools.com.au');
				return;
			}

			$form.find('.teachers').append(teacherHtml(count++));
			updateRepeatingData();
		});

		$form.on('click', '.remove-teacher', function(e) {
			e.preventDefault();
			$(this).closest('.teacher').remove();
			updateRepeatingData();
		});

		$form.on('change', '.teacher input, .teacher select', updateRepeatingData);

		$form.find('.hs_repeating_fields_capturer').hide();
	}

	function handlePaymentPreferenceSubmitButtonNameChange($form) {
		$form.on('change', '.hs_payment_preference input', function() {
			const val = $form.find('.hs_payment_preference input:checked').val();
			$form.find('.hs_submit [type="submit"]').val(val === 'Credit card' ? 'Continue to payment' : 'Request invoice');
		});
	}

	function handleRecentFormSubmissionPathOnFormReady($form) {
		const $recentFormSubmissionPathInput = $form.find('.hs_recent_form_submission_path input');
		if($recentFormSubmissionPathInput.length <= 0) {
			return;
		}

		const path = window.location.pathname;
		$recentFormSubmissionPathInput.val(path).change();
	}

	function handleBecomePartnerFormSubmission($form, data) {
		confetti();

		if(!getParam('auto')) {
			return;
		}

		const tier = data.submissionValues['0-2/partnership_tier'];
		const youtubeId = ((tier === 'Platinum' || tier === 'Gold') ? 'q7kEi5uUnFI' : '3yXXZcSKSw0');

		const modalHtml = `
			<div id="rs-modal-overlay">
				<div id="rs-modal-inner">
					<div id="rs-modal-text">
						<h4>Welcome!</h4>
						<p>Watch the whole video to learn more about the Real Schools Partnership and how to get started.</p>
					</div>
					<div id="rs-modal-video-container">
						<div id="rs-modal-video-fade"></div>
						<div id="rs-modal-youtube"></div>
					</div>
					<div id="rs-modal-finished-text">
						<h4>Thanks for watching!</h4>
						<p>Click the button below to go to the Partner Portal and fill out some more details</p>
						<a id="portal-link" href="https://partner-portal.realschools.com.au/auth/login" target="_blank" class="btn btn-navy">Go to Partner Portal</a>
					</div>
				</div>
			</div>
		`;

		$('body').append(modalHtml);

		setTimeout(() => {
			$('#rs-modal-overlay').css('opacity', 1);
		}, 10);

		// Load YouTube IFrame API if not already loaded
		function loadYouTubeAPI(cb) {
			if (window.YT && window.YT.Player) return cb();
			const tag = document.createElement('script');
			tag.src = 'https://www.youtube.com/iframe_api';
			window.onYouTubeIframeAPIReady = cb;
			document.head.appendChild(tag);
		}

		loadYouTubeAPI(() => {
			new YT.Player('rs-modal-youtube', {
				width: '100%',
				height: '100%',
				videoId: youtubeId,
				events: {
					'onReady': function(e) {
						// Some browsers don't allow autoplay, but we try anyway
						e.target.playVideo();
					},
					'onStateChange': function(e) {
						if (e.data === YT.PlayerState.ENDED) {
							$('#rs-modal-video-fade').css('opacity', 1);
							setTimeout(() => {
								$('#rs-modal-text').fadeOut(500);
								$('#rs-modal-video-container').fadeOut(500, function() {
									$('#rs-modal-finished-text').fadeIn(500);
								});
							}, 500);
						}
					},
				},
				playerVars: {
					rel: 0,
				},
			});
		});

		setTimeout(() => {
			const url = window.rsWebsite.portal.ajaxUrl + `?action=api&controller=publicSchool&method=getChampionLogin`

			$.ajax({
				url: url,
				type: 'POST',
				dataType: 'json',
				data: {
					email: data.submissionValues.email,
					// Wanted to send the time stamp here as well so we could check it against the timestamp on the 
					// server form, but looks like they are a second apart, presumably the difference between the
					// time the browser sends the request and the server recieves it and processes it.
				},
			}).done(function(res) {
				if(!res.success) {
					alert('There was an error getting your Partner Portal login details. Please check your emails to see if you have received them, or contact us at info@realschools.com.au.')
					return;
				}

				const $portalLink = $('#portal-link');
				const href = $portalLink.attr('href');
				const championUsernameEncoded = encodeURIComponent(res.data.championUsername);
				$portalLink.attr('href', href + '?username=' + championUsernameEncoded + '&password=' + championUsernameEncoded);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.error('Error updating partner status:', textStatus, errorThrown);
				alert('There was an error getting your Partner Portal login details. Please check your emails to see if you have received them, or contact us at info@realschools.com.au.')
			});
		// Delay so that our background processing can happen, and set up the company in HS and create the username
		// and push them into the portal so they can log in soon.
		}, 30 * 1000);
	}

	// Test for handleBecomePartnerFormSubmission
	// Enable with ?testing=true
	$(function() {
		if(!getParam('testing')) {
			return;
		}
		
		handleBecomePartnerFormSubmission(null, {
			'redirectUrl': '',
			'submissionValues': {
				// eslint-disable-next-line quotes
				'hs_context': "{\"embedAtTimestamp\":\"1748103461393\",\"formDefinitionUpdatedAt\":\"1746574563146\",\"lang\":\"en\",\"clonedFromForm\":\"29cd21bc-3d09-40c6-9053-1e80ec753548\",\"notifyHubSpotOwner\":\"true\",\"userAgent\":\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/136.0.0.0 Safari/537.36\",\"pageTitle\":\"Real Schools - Become a partner\",\"pageUrl\":\"http://localhost:3082/partnerships/become-partner/\",\"isHubSpotCmsGeneratedPage\":false,\"hutk\":\"d617061c81aefc4fc1d4aa8305ffd7db\",\"__hsfp\":8671264,\"__hssc\":\"181257784.2.1748103206298\",\"__hstc\":\"181257784.d617061c81aefc4fc1d4aa8305ffd7db.1690724479183.1748089185927.1748103206298.408\",\"formTarget\":\"#hbspt-form-ca136980-cb86-45b5-9d51-104837fd8cbe\",\"rumScriptExecuteTime\":252.89999997615814,\"rumTotalRequestTime\":261.59999990463257,\"rumTotalRenderTime\":293.39999997615814,\"rumServiceResponseTime\":8.699999928474426,\"rumFormRenderTime\":31.90000009536743,\"connectionType\":\"4g\",\"firstContentfulPaint\":0,\"largestContentfulPaint\":0,\"locale\":\"en\",\"timestamp\":1748103481806,\"originalEmbedContext\":{\"portalId\":\"9208898\",\"formId\":\"e38ea9d7-cd99-4ab0-a412-b0b4bd3757f8\",\"region\":\"na1\",\"target\":\"#hbspt-form-ca136980-cb86-45b5-9d51-104837fd8cbe\",\"isBuilder\":false,\"isTestPage\":false,\"isPreview\":false,\"isMobileResponsive\":true,\"isInsideFrame\":true,\"shellId\":0,\"pageTitle\":\"Real Schools - Become a partner\",\"pageUrl\":\"http://localhost:3082/partnerships/become-partner/\",\"referrer\":\"\"},\"correlationId\":\"ca136980-cb86-45b5-9d51-104837fd8cbe\",\"renderedFieldsIds\":[\"0-2/partner_status\",\"0-2/partnership_tier\",\"firstname\",\"lastname\",\"email\",\"mobilephone\",\"state_aus\",\"school_linker\",\"job_title_new\"],\"captchaStatus\":\"NOT_APPLICABLE\",\"emailResubscribeStatus\":\"NOT_APPLICABLE\",\"isInsideCrossOriginFrame\":false,\"source\":\"forms-embed-1.8323\",\"sourceName\":\"forms-embed\",\"sourceVersion\":\"1.8323\",\"sourceVersionMajor\":\"1\",\"sourceVersionMinor\":\"8323\",\"allPageIds\":{},\"_debug_embedLogLines\":[{\"clientTimestamp\":1748103463025,\"level\":\"INFO\",\"message\":\"Retrieved customer callbacks used on embed context: [\\\"onFormReady\\\",\\\"onFormSubmitted\\\"]\"},{\"clientTimestamp\":1748103463025,\"level\":\"INFO\",\"message\":\"Retrieved pageContext values which may be overriden by the embed context: {\\\"pageTitle\\\":\\\"Real Schools - Become a partner\\\",\\\"pageUrl\\\":\\\"http://localhost:3082/partnerships/become-partner/\\\",\\\"userAgent\\\":\\\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/136.0.0.0 Safari/537.36\\\",\\\"isHubSpotCmsGeneratedPage\\\":false}\"},{\"clientTimestamp\":1748103463026,\"level\":\"INFO\",\"message\":\"Retrieved countryCode property from normalized embed definition response: \\\"TH\\\"\"},{\"clientTimestamp\":1748103463029,\"level\":\"INFO\",\"message\":\"Retrieved analytics values from API response which may be overriden by the embed context: {\\\"hutk\\\":\\\"d617061c81aefc4fc1d4aa8305ffd7db\\\"}\"}]}",
				'0-2/partner_status': 'Partner',
				'0-2/partnership_tier': 'Gold',
				'firstname': 'Example Principal',
				'lastname': 'Example Principal',
				'email': 'info+principal@lynxdigital.com.au',
				'mobilephone': '+61431041191',
				'state_aus': 'vic',
				'school_linker': 'Example Lynx Digital',
				'job_title_new': 'principal',
			},
		});
	});

	w.rsHubspotFormEmbedOnFormReadyHandler = function($form) {
		handleHsAddStylesOnFormReady($form);
		handleHsLinkerFieldOnFormReady($form);
		handleSelect2StylesOnFormReady($form);
		handleEventNamePickerOnFormReady($form);
		handleMobilePhoneFieldOnFormReady($form);
		handleCountryFieldOnFormReady($form);
		handleRecentFormSubmissionPathOnFormReady($form);

		// Partnership | Become a partner | Tier
		// https://app.hubspot.com/forms/9208898/editor/e38ea9d7-cd99-4ab0-a412-b0b4bd3757f8/edit/form
		if($form.attr('data-form-id') === 'e38ea9d7-cd99-4ab0-a412-b0b4bd3757f8') {
			enlargeRadioField($form, 'partnership_tier');
			handlePartnershipTierSetting($form);
		}

		// Partnership | Renew Partnership
		// https://app.hubspot.com/forms/9208898/editor/ff0492ad-1ba5-4da6-97dd-16eec0101183/edit/form
		if($form.attr('data-form-id') === 'ff0492ad-1ba5-4da6-97dd-16eec0101183') {
			enlargeCheckboxField($form, 'renew_partnership');
		}

		// Restoring Teaching | Resource Request
		// https://app.hubspot.com/submissions/9208898/form/72475b4b-f729-4f2a-b21f-1cffb70cee40/edit/form
		if($form.attr('data-form-id') === '72475b4b-f729-4f2a-b21f-1cffb70cee40') {
			handleRestoringTeachingAutoRedirectOnFormReady($form);
		}

		// Student Behaviour PhD | Enrol | Non-Partner
		// https://app.hubspot.com/forms/9208898/editor/2c6a71f0-2db0-4b0f-8b97-5d31a885b888/edit/form/
		if($form.attr('data-form-id') === '2c6a71f0-2db0-4b0f-8b97-5d31a885b888') {
			handlePhdTicketDetailsField($form);
			handlePaymentPreferenceSubmitButtonNameChange($form);
		}

		// RP2.0 | Enrol
		// https://app.hubspot.com/forms/9208898/editor/f393188f-d112-4354-a80b-b3f8454de719/edit/form/
		if($form.attr('data-form-id') === 'f393188f-d112-4354-a80b-b3f8454de719') {
			handlePaymentPreferenceSubmitButtonNameChange($form);
		}

		// Event | 2025 Keynote | Followup
		// https://app.hubspot.com/forms/9208898/editor/b8a0e7d1-1b70-42aa-8145-b701db8a6ded/edit/form
		if($form.attr('data-form-id') === 'b8a0e7d1-1b70-42aa-8145-b701db8a6ded') {
			hideMobileExceptWhenLeadership($form);
		}
	}

	w.rsHubspotFormEmbedOnFormSubmittedHandler = function($form, data) {
		// Event | 2025 Keynote | Followup
		// https://app.hubspot.com/forms/9208898/editor/b8a0e7d1-1b70-42aa-8145-b701db8a6ded/edit/form
		if($form.hasClass('hs-form-b8a0e7d1-1b70-42aa-8145-b701db8a6ded')) {
			handleKeynoteEnquiryFormOnFormSubmitted(data);
		}

		// Partnership | Become a partner | Tier
		// https://app.hubspot.com/forms/9208898/editor/e38ea9d7-cd99-4ab0-a412-b0b4bd3757f8/edit/form
		if($form.hasClass('hs-form-e38ea9d7-cd99-4ab0-a412-b0b4bd3757f8')) {
			handleBecomePartnerFormSubmission($form, data);
		}

		// Partnership | Renew Partnership
		// https://app.hubspot.com/forms/9208898/editor/ff0492ad-1ba5-4da6-97dd-16eec0101183/edit/form
		if($form.hasClass('hs-form-ff0492ad-1ba5-4da6-97dd-16eec0101183')) {
			confetti();
		}

		// Restoring Teaching | Resource Request
		// https://app.hubspot.com/submissions/9208898/form/72475b4b-f729-4f2a-b21f-1cffb70cee40/edit/form
		if($form.hasClass('hs-form-72475b4b-f729-4f2a-b21f-1cffb70cee40')) {
			handleRestoringTeachingAutoRedirectOnFormSubmitted();
		}

		// Student Behaviour PhD | Enrol | Non-Partner
		// https://app.hubspot.com/forms/9208898/editor/2c6a71f0-2db0-4b0f-8b97-5d31a885b888/edit/form/
		if($form.hasClass('hs-form-2c6a71f0-2db0-4b0f-8b97-5d31a885b888')) {
			handleNonPartnerPhdPurchaseRedirectOnFormSubmitted(data);
		}

		// RP2.0 | Enrol
		// https://app.hubspot.com/forms/9208898/editor/f393188f-d112-4354-a80b-b3f8454de719/edit/form/
		if($form.hasClass('hs-form-f393188f-d112-4354-a80b-b3f8454de719')) {
			handleRp2OnlineRedirectOnFormSubmitted(data);
		}

		// Lead Generation
		// https://app.hubspot.com/forms/9208898/editor/20780a65-f08c-45f7-9a1f-12e5a3250efe/
		if($form.hasClass('hs-form-20780a65-f08c-45f7-9a1f-12e5a3250efe')) {
			handleLeadGenerationRedirect(data);
		}
	}

	if(window.gform) {
		gform.addFilter('gpnf_modal_args', function(args, _formId, _fieldId, nestedFormObject) {
			if(!nestedFormObject.$parentFormContainer.hasClass('gf-form-recommendation')) {
				return args;
			}
	
			args.labels.title = 'Add';
			args.cssClass.push('gf-form-recommendation-modal');
			nestedFormObject.$parentFormContainer.addClass('gpnf-disable-responsive-table');
			
			return args;
		});
	}
})(window, jQuery);

(function(w, $) {
	const $d = $(document);

	$d.on('click', '#enrol-buttons .wpb_column .gem-button', function(e) {
		e.preventDefault();
	});

	$d.on('click', '#enrol-buttons .wpb_column', function() {
		$(this).closest('.vc_row').find('.wpb_column-active').removeClass('wpb_column-active');
		$(this).addClass('wpb_column-active');

		const id = $(this).attr('id');
		const formId = 'form-' + id;

		$d.find('#forms .vc_row:not(#'+formId+')').css('max-height', '0px');
		$d.find('#forms #'+formId+'').css('max-height', '3000px');

		$('html').animate({
			scrollTop: $d.find('#forms').offset().top - 200,
		}, 1000);
	})
})(window, jQuery);


(function(w, $) {
	w.addEventListener('message', function(event) {
		if(event.data.type !== 'resize') {
			return;
		}

		// nitro-lazy-src is used by WPEngine full page caching
		$('iframe[src*="rsEmbed"], iframe[nitro-lazy-src*="rsEmbed"]').css({
			minHeight: event.data.height,
		});
	});
})(window, jQuery);

(function(w, $) {
	$(function() {
		const $eventsContainer = $('#events');
		if(!$eventsContainer.length) {
			return;
		}

		const $events = $eventsContainer.find('.event');
		const $noEvents = $eventsContainer.find('.no-events');

		$eventsContainer.find('#event-state, #event-for, #event-medium').on('change', function() {
			const stateFilter = $eventsContainer.find('#event-state').val();
			const forFilter = $eventsContainer.find('#event-for').val();
			const mediumFilter = $eventsContainer.find('#event-medium').val();

			$events.each((i, event) => {
				const $event = $(event);

				const eventStateAttr = $event.attr('data-event-state');
				const eventForAttr = $event.attr('data-event-for');
				const eventMediumAttr = $event.attr('data-event-medium');

				let matchesState = (stateFilter === '' || eventStateAttr === stateFilter);
				const matchesFor = (forFilter === '' || eventForAttr === forFilter);
				const matchesMedium = (mediumFilter === '' || eventMediumAttr === mediumFilter);

				if(eventMediumAttr === 'online' && matchesMedium) {
					matchesState = true;
				}

				$event.toggleClass('event-hidden', !(matchesState && matchesFor && matchesMedium));
			});

			let allEventsHidden = true;
			let visiableEventIndex = 0;
			$events.each((i, event) => {
				const $event = $(event);

				if(!$event.hasClass('event-hidden')) {
					visiableEventIndex++;
					$event.toggleClass('event-odd', (visiableEventIndex % 2 === 0));
					allEventsHidden = false;
				}
			});
			
			$noEvents.toggleClass('event-hidden', !allEventsHidden);
		});
	});
})(window, jQuery);
